import React from 'react';
interface StatusIndicatorProps {
  status: 'green' | 'yellow' | 'red';
  size?: 'small' | 'medium' | 'large';
}
export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  status,
  size = 'medium'
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'w-6 h-6';
      case 'medium':
        return 'w-10 h-10';
      case 'large':
        return 'w-20 h-20';
      default:
        return 'w-10 h-10';
    }
  };
  const getColorClasses = () => {
    switch (status) {
      case 'green':
        return 'bg-green-500';
      case 'yellow':
        return 'bg-yellow-500';
      case 'red':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };
  const getLabel = () => {
    switch (status) {
      case 'green':
        return 'Baseline';
      case 'yellow':
        return 'Inflamed';
      case 'red':
        return 'Infection Risk';
      default:
        return 'Unknown';
    }
  };
  return <div className="flex flex-col items-center" data-id="element-238">
      <div className={`${getSizeClasses()} ${getColorClasses()} rounded-full shadow-md flex items-center justify-center`} aria-label={`Status: ${getLabel()}`} data-id="element-239">
        {size === 'large' && <span className="text-white font-medium" data-id="element-240">
            {status === 'green' && '✓'}
            {status === 'yellow' && '!'}
            {status === 'red' && '✗'}
          </span>}
      </div>
      {size === 'large' && <span className="mt-2 text-sm font-medium" data-id="element-241">
          {status === 'green' && <span className="text-green-600" data-id="element-242">Baseline</span>}
          {status === 'yellow' && <span className="text-yellow-600" data-id="element-243">Inflamed</span>}
          {status === 'red' && <span className="text-red-600" data-id="element-244">Infection Risk</span>}
        </span>}
    </div>;
};